import { RouterLink } from 'sierra-client/components/common/link'
import { FCC } from 'sierra-client/types'

export const EditionPageLink: FCC = ({ children }) => (
  <RouterLink href={'/select-edition?skipAssignmentCheck=enabled'}>{children}</RouterLink>
)
